<template>
  <base-list
    key="tab1"
    :items="customers"
    :loading="loading"
  >
    <template v-slot:loading>
      <base-skeleton
        v-for="n in 3"
        :key="n"
        :opacity="0 + (1 /n)"
      >
        <div class="d-flex justify-content-between mb-2">
          <div class="w-100">
            <div
              class="skeleton__item"
              style="max-width: 200px"
            />
            <div
              class="skeleton__item"
              style="max-width: 120px"
            />
          </div>
          <div
            class="skeleton__item mt-0 ml-2"
            style="max-width: 40px"
          />
        </div>
        <div class="d-flex">
          <div
            v-for="s in 3"
            :key="s"
            class="skeleton__item mr-2 mt-2"
            style="width: 120px; height: 120px"
          />
        </div>
      </base-skeleton>
    </template>
    <template v-slot:nodata>
      <empty
        :align="115"
        :title="`No ${shoppingListNoun} history yet`"
        :subtitle="`Create an edit to start receiving ${shoppingListNoun} history`"
      />
    </template>
    <template v-slot:default="{item: {first_name, last_name, email, pk, last_added, cartproducts}}">
      <activity-cell
        :name="`${first_name} ${last_name}`"
        :identifier="pk"
        :email="email"
        :date="last_added"
        :items="mappedproducts(cartproducts)"
        :item-id="pk"
      />
    </template>
  </base-list>
</template>
<script>
import Listable from '@/components/mixins/listable';
import ActivityCell from './ActivityCell';

export default {
  name: 'ShoppingList',
  components: { ActivityCell },
  mixins: [Listable],
  props: {
    source: {
      type: String,
      default: 'customerProducts',
    },
    mode: {
      type: String,
      default: 'loadMore',
    },
  },
  data() {
    return {};
  },
  computed: {
    customers() {
      return this.$store.state.customerProducts.items;
    },
    shoppingListNoun() {
      // XXX  dlam tried mixing in 'integrable' to re-use code
      //      but got a weird-as-hell-error, giving up
      if (this.$store.state.account.user.profile.ui.integrates_wishlists) {
        return 'wishlist';
      } else {
        return 'shopping list';
      }
    },

  },
  methods: {
    getDate(cart) {
      return cart.last_update || cart.created;
    },
    /** Prepares the data for activity cell */
    mappedproducts(cartproducts) {
      return cartproducts.map((item) => ({
        ...item.product,
        date: item.added,
      }));
    },
  },
};
</script>
